import { createSvgIcon } from 'shared/icons/IconUtils';

export const AddLoadAlertIcon = createSvgIcon(
  'AddLoadAlertIcon',

  <path
    clipRule="evenodd"
    fillRule="evenodd"
    d="M9.99967 18.3333C10.9163 18.3333 11.6663 17.5833 11.6663 16.6666H8.33301C8.33301 17.5833 9.08301 18.3333 9.99967 18.3333ZM14.9997 13.3333V12.2154C14.3786 11.9959 13.8139 11.6572 13.333 11.2268V14.1666H6.66634V9.16658C6.66634 7.09992 7.92467 5.41659 9.99967 5.41659C10.7425 5.41659 11.3807 5.63232 11.8939 6.00414C12.0668 5.45197 12.3329 4.94101 12.6737 4.48966C12.2513 4.22517 11.7754 4.02449 11.2497 3.89992V3.33325C11.2497 2.64159 10.6913 2.08325 9.99967 2.08325C9.30801 2.08325 8.74967 2.64159 8.74967 3.33325V3.89992C6.36634 4.46659 4.99967 6.59992 4.99967 9.16658V13.3333L3.33301 14.9999V15.8333H16.6663V14.9999L14.9997 13.3333ZM15.833 4.16659H17.4997V6.66658H19.9997V8.33325H17.4997V10.8333H15.833V8.33325H13.333V6.66658H15.833V4.16659Z"
  />,
  { viewBox: '0 0 22 22' },
);
